import { MarketingHeader } from "@/components/marketing/MarketingHeader";
import { MarketingFooter } from "@/components/marketing/MarketingFooter";
import { motion } from "framer-motion";

const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 }
};

export default function About() {
  return (
    <div className="min-h-screen bg-background">
      <MarketingHeader />
      
      <main className="pt-24 pb-20">
        <article className="max-w-2xl mx-auto px-6">
          <motion.header 
            className="mb-12"
            initial="hidden"
            animate="visible"
            variants={fadeIn}
            transition={{ duration: 0.5 }}
          >
            <h1 className="text-3xl md:text-4xl font-medium text-foreground mb-4">
              Why YELV exists
            </h1>
            <div className="h-px bg-border w-16" />
          </motion.header>

          <motion.div 
            className="space-y-6 text-muted-foreground text-lg leading-relaxed"
            initial="hidden"
            animate="visible"
            variants={fadeIn}
            transition={{ duration: 0.5, delay: 0.15 }}
          >
            <p>
              Most ideas don't fail because they're bad.
            </p>
            
            <p>
              They dissolve. They slip away in the space between capture and action. 
              They get lost in note apps, forgotten in browser tabs, buried under 
              newer thoughts before they ever had a chance to prove themselves.
            </p>

            <p>
              We've watched founders, operators, and builders lose ideas not to 
              competition or market forces — but to the simple lack of a system 
              that makes ideas stick.
            </p>

            <p className="text-foreground font-medium">
              YELV was built to solve this.
            </p>

            <p>
              It's a structured thinking system — not a note app, not a task manager, 
              not a project board. It's a place where ideas are captured before they 
              fade, forced through structure so their substance becomes visible, and 
              nurtured over time until they either grow into something real or are 
              deliberately set aside.
            </p>

            <p>
              The design is intentional. Capture is effortless. Structure is required. 
              Return is encouraged. Growth is earned.
            </p>

            <p>
              There's no gamification. No productivity metrics. No guilt mechanics. 
              Just a calm, intelligent environment for the kind of thinking that 
              deserves to survive.
            </p>

            <div className="pt-8 border-t border-border mt-12">
              <p className="text-foreground">
                Ideas deserve roots.
              </p>
              <p className="text-sm text-muted-foreground mt-4">
                — The YELV team
              </p>
            </div>
          </motion.div>
        </article>
      </main>
      
      <MarketingFooter />
    </div>
  );
}
